<template>
  <el-dialog
    :visible.sync="dialogShow"
    v-bind:destroy-on-close="true"
    v-bind="allProps"
    :close-on-click-modal="false"
    append-to-body
  >
    <component :is="componentImstances" ref="sub" v-on="allMethods" />
    <div class="h60 pt20 ta-r" v-if="allProps.hasOwnProperty('yes')">
      <el-button type="default" @click="hide">关闭</el-button>
      <el-button type="primary" @click="yes">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogShow: false,
    };
  },
  props: {
    path: {
      type: String,
      default: "",
    },
  },
  computed: {
    allProps() {
      return this.$attrs;
    },
    allMethods() {
      var methods = {
        show: this.show,
        hide: this.hide,
      };
      return Object.assign(methods, this.$listeners);
    },
    componentImstances() {
      return (resolve) => require([`@/views/${this.path}`], resolve);
    },
  },
  methods: {
    yes() {
      if (this.$refs.sub.yes && typeof this.$refs.sub.yes == "function") {
        this.$refs.sub.yes((x) => {
          this.hide();
        });
      }
    },
    show() {
      this.dialogShow = true;
      setTimeout(() => {
        if (this.$refs.sub.init && typeof this.$refs.sub.init == "function") {
          this.$refs.sub.init(...arguments);
        }
      }, 0);
    },
    hide() {
      this.dialogShow = false;
    },
  },
};
</script>
<style lang="scss">
.el-dialog {
  border-radius: 5px;
  .el-dialog__header {
    .el-dialog__title {
      font-weight: bold;
    }
    border-bottom: 1px solid #f2f2f2;
  }
  .el-dialog__body {
    padding: 20px 20px 20px 20px;
  }
}
.el-form--inline .el-form-item__content {
  display: table;
}
.el-form--inline .el-form-item__label {
  float: left;
}
</style>
